<div class="modals modal-orders-history-new" [class.modal-orders-history-new-show]="isModalOrdersHistoryNewShow">
  <div class="delivery">
    <ng-container *ngIf="delivery && delivery.length && areas">
      <ng-container *ngFor="let del of delivery">
        <!-- Умови кур'єрської доставки - лише для адресних доставок (1 і >30), як у боті (m_telega_texts).
             Колишнє (id !== 1 || id <= 30) було завжди true, і блок з цінами кур'єра отримувало таксі (9) з областю. -->
        <div *ngIf="del.area_id != null && (del.id == 1 || del.id > 30)">
          <h4>{{ (del.name_del === undefined || del.name_del === '') ? del.name : del.name_del }}</h4>
          <p>До {{ user.del_summa1 }} грн. можливі замовлення самовивозом, а також відправка перевізником.</p>
          <p>Доставка нашим кур'єром
            <!--            по {{areas[del.area_id].name}} області -->
            можлива при замовленні
            від {{ user.del_summa1 }} грн.
            <b>Замовлення доставляється за адресою.</b></p>
          <ul class="delivery-prices">
            <li>Замовлення від {{ user.del_summa1 }} грн. - вартість доставки {{ user.del_cost }} грн;</li>
            <li *ngIf="user.del_cost > 0">Замовлення від {{ user.del_summa2 }} грн. - доставка за наш рахунок!</li>
          </ul>
          <p>
            <b>Важливо!</b>
            Приймаємо дозаказ
            {{ del.working_details.working_now ? 'до ' + del.working_details.till_time : 'до ' + del.working_details.next_working_day_till }}
            дня доставки.
            <ng-container *ngIf="user.del_cost > 0">
              Якщо до дня доставки, загальна сума замовлення {{ user.del_summa2 }} грн і вище,
              система автоматично відніме {{ user.del_cost }} грн з доставки.
            </ng-container>
          </p>
          <p>Для зміни умов доставки зверніться до адміністратора.<br>Меню - наші контакти.</p>
        </div>
      </ng-container>
    </ng-container>

    <div class="text-content">
      <p>Самовивіз в м. Київ.</p>
      <p>Самовивіз з центрального складу можливий тільки за попереднім погодженням з адміністратором сайту і при
        мінімальному замовленні піддону (800 літрів в асортименті).</p>
      <br>
      <p>Доставка по Україні здійснюється перевізниками - Нова пошта, Делівері.
        Замовлення кратно піддону ({{ user ? user.np_big_delivery_liters : '' }} літрів в асортименті оплачуємо
        пересилку
        перевізником Нова Пошта або дозагрузом)</p>
      <p>Відправляємо по Дропшиппінг. (Відправлення від вашого імені на ім'я вашого клієнта).</p>
      <p *ngIf="!isDropship">
        <strong>Для активації способу доставки «Дропшип» будь ласка зверніться до адміністратора сайту.</strong>
      </p>
      <p *ngIf="!activeOrganization || activeOrganization.type === 'fiz'">Відправляємо накладеним платежем на вашого клієнта.</p>

      <div class="text-content">
        <p class="attention-text">Увага!</p>
        <p>За всіма відправками перевізниками Нова пошта, Делівері встановлено автоповернення посилок
          відправнику!
          Відправник не несе відповідальності за несвоєчасно отримані посилки!</p>
      </div>

      <div class="text-content">
        <p class="attention-text">Увага!</p>
        <p>Тільки для Нової Пошти і Дропшип!
          Через вимоги перевізника Нова Пошта - посилки мають бути запаковані обов’язково в коробки, тому в замовленнях
          меньших за заводську коробку (ящика)</p>
        <p>додатково враховується вартість упаковки.</p>
        <p>Якщо літражність товарів замовлення менше 5 літрів, то вартість упаковки дорівнюватиме 20 грн. Якщо 5 та
          більше літрів, то 25 грн. 11 літрів і більше 0 грн.</p>
      </div>

      <div class="text-content" *ngIf="!activeOrganization || activeOrganization.type === 'fiz'">
        <p class="attention-text">Увага!</p>
        <p>
          При оформленні замовлень з накладеним платежем додається відсоток {{ nalojkaMarkup }}% за обробку замовлення.
        </p>
      </div>

      <div><a class="button" (click)="closeModal()">Ознайомлений</a></div>
    </div>
  </div>
</div>

<div class="dark-layer" [class.modals-show]="isDarkBackground" (click)="closeModal()"></div>
